export default __webpack_public_path__ + "static/media/Upwork.188e1e84.png";